module.exports = __webpack_public_path__ + "media/images/pcidss-white-1c92c6ca44e5465aa00745c289be0f5e.png";